import React from "react";
import CustomSelect from "../../atoms/CustomSelect/CustomSelect";
import CustomSelectLanguage from "../../atoms/CustomSelect/CustomSelectLanguage";

const parseHtmlContent = (htmlString) => {

    const jsonData = { links: [] };

    const parser = new DOMParser();
    const dom = parser.parseFromString(htmlString, "text/html");
    Array.from(dom.getElementsByTagName('a')).forEach((link, i) => {
        jsonData.links.push({
            label: link.innerText.trim(),
            value: link.getAttribute("href"),
            target: link.getAttribute("target")
        });
    });

    return jsonData;
}

const LinksDropdown = (props) => {

    const {
        changeLanguage,
        menuPlacement,
        defaultValueIndex,
        placeholder,
        links,
        innerHTML
    } = props;

    // options can be passed as props.links (if used by other React component)
    // or as innerHTML (if initialized from HTML markup)
    const options = (!links && innerHTML && innerHTML !== '' ? parseHtmlContent(innerHTML).links : links );

    if(!options || !options.length) {
        return null;
    }

    const onChange = ({value, target}) => {
        if(value && value !== '' && target !== '_blank') {
            document.location.href = value;
        }
        if(value && value !== '' && target === '_blank') {
            window.open(value);
        }
    }

    const defaultValue = defaultValueIndex ? options[defaultValueIndex] : null;

    return (
        <>
            {changeLanguage ?
                <CustomSelectLanguage
                    placeholder={placeholder}
                    isSearchable={false}
                    menuPlacement={menuPlacement}
                    defaultValue={options[0]}
                    options={options}
                    onChange={onChange}
                />
                :
                <CustomSelect
                    placeholder={placeholder}
                    isSearchable={false}
                    defaultValue={defaultValue}
                    options={options}
                    onChange={onChange}
                />
            }
        </>
    )

}

export default LinksDropdown;
